/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingalreadyexistserror3Inputs */

const en_listingalreadyexistserror3 = /** @type {(inputs: Listingalreadyexistserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A listing with this name already exists.`)
};

const de_listingalreadyexistserror3 = /** @type {(inputs: Listingalreadyexistserror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Ort mit diesem Namen gibt es schon.`)
};

/**
* | output |
* | --- |
* | "A listing with this name already exists." |
*
* @param {Listingalreadyexistserror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingalreadyexistserror3 = /** @type {((inputs?: Listingalreadyexistserror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingalreadyexistserror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingalreadyexistserror3(inputs)
	return de_listingalreadyexistserror3(inputs)
});
export { listingalreadyexistserror3 as "listingAlreadyExistsError" }